var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PilotView"},[_c('ApplicationBanner',{attrs:{"content":"<h1>Please read and agree<br>to our Privacy Agreement</h1>"}}),_c('Page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }